import { createApp, watch, h } from 'vue'
import { siteIdentity, companyText, companyHtml, refreshIdentity, siteAvailability, defaultSettings } from './services/corporateSite'
import MaintenancePage from './views/MaintenancePage.vue'
import 'aos/dist/aos.css'
import './styles/corporate-theme.css'

// Load page code and identity together; mount only once the actual company name is known.
const components = Promise.all([import('./App.vue'), import('./router'), import('./store')])
async function start() {
  try {
    const [[{ default: App }, { default: router }, { default: store }]] = await Promise.all([components, refreshIdentity().catch(error => { if (!siteAvailability.maintenance) throw error })])
    const retry = () => refreshIdentity().catch(() => {})
    const app = createApp({ render: () => siteAvailability.maintenance
      ? h(MaintenancePage, { busy: siteAvailability.refreshing, onRetry: retry })
      : h(App) })
    app.config.globalProperties.$site = siteIdentity
    app.config.globalProperties.$companyText = companyText
    app.config.globalProperties.$companyHtml = companyHtml
    app.use(store).use(router)
    await router.isReady()
    const titles = { home: 'Головна', cash: 'Кошти в кредит', loan: 'Кошти в кредит', good: 'Кредит на товар', about: 'Про нас', law: 'Правова інформація', menu: 'Меню', news: 'Новини', newsArticle: 'Новини', creditCalculator: 'Кредитні продукти', police: 'Політика конфіденційності', contacts: 'Контакти', faq: 'Питання та відповіді' }
    watch(() => [siteIdentity.display_name, router.currentRoute.value.name, siteAvailability.maintenance], () => {
      const brand = siteAvailability.maintenance ? defaultSettings.display_name : siteIdentity.display_name
      document.title = `${brand || 'Фінансова компанія'} | ${siteAvailability.maintenance ? 'Maintenance' : titles[router.currentRoute.value.name] || ''}`
    }, { immediate: true })
    router.afterEach(() => { refreshIdentity().catch(() => {}) })
    document.getElementById('app').removeAttribute('style')
    app.mount('#app')
    const refresh = () => { if (!document.hidden) refreshIdentity().catch(() => {}) }
    window.addEventListener('focus', refresh)
    document.addEventListener('visibilitychange', refresh)
    window.setInterval(refresh, 30000)
  } catch (error) {
    console.error('Не вдалося запустити сайт:', error)
    const root = document.getElementById('app')
    root.replaceChildren()
    root.removeAttribute('style')
    document.title = `${defaultSettings.display_name || 'Фінансова компанія'} | Maintenance`
    createApp(MaintenancePage, { onRetry: () => window.location.reload() }).mount(root)
  }
}
start()
